import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
export default {
    async sampleExcel() {
        return await axios.get(`lang/sample-excel-language`);
    },
    async excelImport(payload){
        return await axios.post(`lang/import-excel-language`,payload);
    },
    async create(model) {
        return await axios.post(`lang`, model)
    },
    async fetchById(id) {
        return await axios.get(`lang/${id}`)
    },
    async fetch(query, page) {
      
        return await axios.get(`lang/data?q=${query}&page=${page}`);
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`lang/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`lang/${id}`)
    },
  
}
